// MUI Imports
import type { Theme } from "@mui/material/styles";

// Type Imports
import type { SystemMode } from "@core/types";

const customShadows = (mode: SystemMode): Theme["customShadows"] => {
  return {
    xs: `0px 2px 6px rgb(var(--mui-mainColorChannels-${mode}Shadow) / ${mode === "light" ? 0.14 : 0.2})`,
    sm: `0px 2px 10px rgb(var(--mui-mainColorChannels-${mode}Shadow) / ${mode === "light" ? 0.16 : 0.24})`,
    md: `0px 4px 14px rgb(var(--mui-mainColorChannels-${mode}Shadow) / ${mode === "light" ? 0.16 : 0.26})`,
    lg: `0px 6px 20px rgb(var(--mui-mainColorChannels-${mode}Shadow) / ${mode === "light" ? 0.18 : 0.28})`,
    xl: `0px 8px 26px rgb(var(--mui-mainColorChannels-${mode}Shadow) / ${mode === "light" ? 0.18 : 0.3})`,
  };
};

export default customShadows;
